/**
 * @generated SignedSource<<20ce7f1052fd94471c3ec9363a644de2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselThumb_videoVimeo$data = {
  readonly thumbThumbnail: string | null;
  readonly " $fragmentType": "HeroCarouselThumb_videoVimeo";
};
export type HeroCarouselThumb_videoVimeo$key = {
  readonly " $data"?: HeroCarouselThumb_videoVimeo$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_videoVimeo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselThumb_videoVimeo",
  "selections": [
    {
      "alias": "thumbThumbnail",
      "args": [
        {
          "kind": "Literal",
          "name": "includePlayButton",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "pad",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "size",
          "value": "w200h150"
        }
      ],
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w200h150\")"
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "0d92998be2ab8994bcecc2722d6907c7";

export default node;
